import { render, staticRenderFns } from "./MultipleChoiceAnswerResource.vue?vue&type=template&id=d997412a&"
import script from "./MultipleChoiceAnswerResource.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceAnswerResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports